<div class="main-menu">
  <ul class="d-flex list-unStyle">
    @for (item of menuItems; track item) {
      <li>
        @if (item.className) {
          <a [routerLink] = "'/'+item.routerLink" [routerLinkActive]="['active-link']"
          [queryParams]="{display: 'grid'}">{{item.name}}</a>
        }
        @if (!item.className) {
          <a [routerLink]="'/'+item.routerLink" [routerLinkActive]="['active-link']">{{item.name}}</a>
        }
      </li>
    }
  </ul>
</div>